import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=183a20f4&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a20f4",
  null
  
)

export default component.exports